<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="companyProfile; else showMessage">
    <div class="company-profile-wrapper">
      <button class="back-btn" (click)="goBack()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Back
      </button>

      <div class="hero-banner-card">
        <div class="banner-gradient"></div>
        <div class="banner-bottom">
          <div
            class="company-logo-box"
            [class.has-img]="!!companyProfileForm.get('logo_url')?.value"
          >
            <ng-container *ngIf="!companyProfileForm.get('logo_url')?.value">
              {{ companyProfile.company_name.charAt(0).toUpperCase() || "C" }}
            </ng-container>
            <img
              *ngIf="companyProfileForm.get('logo_url')?.value"
              [src]="getLogoUrl(companyProfileForm.get('logo_url')?.value)"
              class="logo-img"
              alt="Company Logo"
            />
          </div>
          <h1 class="company-name-heading">
            {{ companyProfile.company_name }}
          </h1>
        </div>
      </div>

      <div class="profile-card">
        <div class="card-header-row">
          <div class="header-title-group">
            <div class="title-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              </svg>
            </div>
            <div>
              <h2 class="card-title">Company Profile Details</h2>
              <p class="card-subtitle">
                Public details and contact information about your organization
              </p>
            </div>
          </div>

          <div class="header-actions">
            <button
              class="btn-edit"
              *ngIf="!isEditMode"
              (click)="toggleEditMode()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 20h9" />
                <path
                  d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                />
              </svg>
              Edit
            </button>

            <ng-container *ngIf="isEditMode">
              <button class="btn-cancel" (click)="cancelEdit()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                Cancel
              </button>
              <button class="btn-save" [disabled]="companyProfileForm.invalid" (click)="saveProfile()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                  />
                  <polyline points="17 21 17 13 7 13 7 21" />
                  <polyline points="7 3 7 8 15 8" />
                </svg>
                Save
              </button>
            </ng-container>
          </div>
        </div>

        <div class="card-body view-mode-body" *ngIf="!isEditMode">
          <h3 class="section-divider-title">Company Information</h3>
          <div class="logo-display-group">
            <label class="field-lbl">Company Logo</label>
            <div
              class="logo-preview-box"
              [class.has-img]="!!companyProfileForm.get('logo_url')?.value"
            >
              <ng-container *ngIf="!companyProfileForm.get('logo_url')?.value">
                {{ companyProfile.company_name.charAt(0).toUpperCase() || "C" }}
              </ng-container>
              <img
                *ngIf="companyProfileForm.get('logo_url')?.value"
                [src]="getLogoUrl(companyProfileForm.get('logo_url')?.value)"
                class="logo-img"
                alt="Company Logo"
              />
            </div>
          </div>

          <div class="form-grid">
            <div class="field-item">
              <label class="field-lbl">Company Name</label>
              <p class="field-val">{{ companyProfile.company_name || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">Industry</label>
              <p class="field-val">{{ companyProfile.industry || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">Default Job Passing Score (%)</label>
              <p class="field-val">{{ companyProfile.default_passing_score || 40 }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                Company Official Email
              </label>
              <p class="field-val">
                {{ companyProfile.contact.official_email || "—" }}
              </p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path
                    d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                  />
                </svg>
                Website
              </label>
              <p class="field-val">{{ companyProfile.company_url || "—" }}</p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                  />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
                LinkedIn
              </label>
              <p class="field-val">
                {{ companyProfile.linkedin_profile || "—" }}
              </p>
            </div>
          </div>

          <div class="field-item full-width">
            <label class="field-lbl">About</label>
            <p class="field-val">{{ companyProfile.about_company || "—" }}</p>
          </div>

          <div class="field-item full-width">
            <label class="field-lbl">
              <svg
                class="lbl-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              Office Locations
            </label>
            <div
              class="locations-list"
              *ngIf="companyProfile.office_locations.length; else noLocation"
            >
              <p
                class="field-val"
                *ngFor="let loc of companyProfile.office_locations"
              >
                {{ loc }}
              </p>
            </div>
            <ng-template #noLocation><p class="field-val">—</p></ng-template>
          </div>

          <h3 class="section-divider-title">Point of Contact</h3>
          <p class="section-desc">Primary recruiter contact for BeExpert</p>
          <div class="form-grid">
            <div class="field-item">
              <label class="field-lbl">Contact Person</label>
              <p class="field-val">
                {{ companyProfile.contact.poc_name || "—" }}
              </p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                Email
              </label>
              <p class="field-val">
                {{ companyProfile.contact.poc_email || "—" }}
              </p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  />
                </svg>
                Mobile
              </label>
              <p class="field-val">
                {{ companyProfile.contact.poc_phone || "—" }}
              </p>
            </div>
          </div>

          <h3 class="section-divider-title">HR Contact</h3>
          <p class="section-desc">Hiring team contact details</p>
          <div class="form-grid">
            <div class="field-item">
              <label class="field-lbl">HR Name</label>
              <p class="field-val">
                {{ companyProfile.contact.hr_name || "—" }}
              </p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                HR Email
              </label>
              <p class="field-val">
                {{ companyProfile.contact.hr_email || "—" }}
              </p>
            </div>
            <div class="field-item">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  />
                </svg>
                HR Phone
              </label>
              <p class="field-val">
                {{ companyProfile.contact.hr_phone || "—" }}
              </p>
            </div>
          </div>
        </div>

        <!-- EDIT MODE -->
        <form [formGroup]="companyProfileForm">
          <div class="card-body edit-mode-body" *ngIf="isEditMode">
            <!-- Company Information Section -->
            <h3 class="section-divider-title">Company Information</h3>

            <div class="logo-edit-group">
              <label class="field-lbl">Company Logo</label>
              <div class="logo-uploader-row">
                <div
                  class="logo-preview-box sm"
                  [class.has-img]="!!companyProfileForm.get('logo_url')?.value"
                >
                  <ng-container
                    *ngIf="!companyProfileForm.get('logo_url')?.value"
                  >
                    {{
                      companyProfile.company_name.charAt(0).toUpperCase() || "C"
                    }}
                  </ng-container>
                  <img
                    *ngIf="companyProfileForm.get('logo_url')?.value"
                    [src]="getLogoUrl(companyProfileForm.get('logo_url')?.value)"
                    class="logo-img"
                    alt="Company Logo"
                  />
                </div>
                <div class="logo-actions">
                  <!-- Hidden File Input -->
                  <input
                    type="file"
                    #fileInput
                    (change)="onLogoSelected($event)"
                    accept="image/png, image/jpeg, image/svg+xml"
                    style="display: none"
                  />

                  <button
                    class="btn-change-logo"
                    (click)="triggerFileInput(fileInput)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                    Change logo
                  </button>
                  <button
                    class="btn-remove-logo"
                    (click)="removeLogo()"
                    *ngIf="companyProfileForm.get('logo_url')?.value"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                    Remove
                  </button>
                  <span class="logo-hint">PNG, JPG or SVG up to 2MB</span>
                </div>
              </div>
            </div>

            <div class="form-grid">
              <div class="field-item">
                <label class="field-lbl">Company Name<span class="required-star">*</span></label>
                <input
                  type="text"
                  class="standard-input"
                  formControlName="company_name"
                  placeholder="Enter company name"
                />

              <small
                class="text-danger smaller-text"
                *ngIf="
                  companyProfileForm.get('company_name')?.touched &&
                  companyProfileForm.get('company_name')?.hasError('required')">
                Company Name is required
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('company_name')?.dirty ||
                    companyProfileForm.get('company_name')?.touched) &&
                  companyProfileForm.get('company_name')?.hasError('minLengthName')">
                Company Name must be at least 2 characters long.
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('company_name')?.dirty ||
                    companyProfileForm.get('company_name')?.touched) &&
                  companyProfileForm.get('namcompany_namee')?.hasError('invalidName')">
                Please enter a valid company name. Company Name can contain only letters, spaces,
                apostrophes, periods and hyphens.
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('company_name')?.dirty ||
                    companyProfileForm.get('company_name')?.touched) &&
                  companyProfileForm.get('company_name')?.hasError('maxLengthName')">
                Maximum 100 characters allowed</small
              >
              </div>
              <div class="field-item">
                <label class="field-lbl">Industry<span class="required-star">*</span></label>
                <input
                  type="text"
                  class="standard-input"
                  formControlName="industry"
                  placeholder="e.g. Information Technology"
                />
              </div>
              <div class="field-item">
                <label class="field-lbl">Default Job Passing Score (%)</label>
                <input
                  type="number"
                  class="standard-input"
                  formControlName="default_passing_score"
                  placeholder="e.g. 40"
                  min="1"
                  max="100"
                />

              <small
                class="text-danger smaller-text"
                *ngIf="
                  companyProfileForm.get('industry')?.touched &&
                  companyProfileForm.get('industry')?.hasError('required')
                "
              >
                Industry Name is required
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('industry')?.dirty ||
                    companyProfileForm.get('industry')?.touched) &&
                  companyProfileForm.get('industry')?.hasError('minLengthName')
                "
              >
                Industry Name must be at least 2 characters long.
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('industry')?.dirty ||
                    companyProfileForm.get('industry')?.touched) &&
                  companyProfileForm.get('industry')?.hasError('invalidName')
                "
              >
                Please enter a valid industry name. Industry Name can contain only letters, spaces,
                apostrophes, periods and hyphens.
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('industry')?.dirty ||
                    companyProfileForm.get('industry')?.touched) &&
                  companyProfileForm.get('industry')?.hasError('maxLengthName')
                "
              >
                Maximum 100 characters allowed</small
              >
              </div>
              <div class="field-item">
                <label class="field-lbl">
                  <svg
                    class="lbl-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  Company Official Email<span class="required-star">*</span>
                </label>
                <div formGroupName="contact">
                  <input
                    type="email"
                    class="standard-input"
                    formControlName="official_email"
                    placeholder="Enter official email"
                  />
                  <small
              class="text-danger smaller-text"
              *ngIf="
                companyProfileForm.get('official_email')?.touched &&
                companyProfileForm.get('official_email')?.hasError('required')
              "
            >
              Email is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (companyProfileForm.get('official_email')?.dirty ||
                companyProfileForm.get('official_email')?.touched) &&
                companyProfileForm.get('official_email')?.hasError('emailSpace')
              "
            >
              Email address cannot contain spaces.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (companyProfileForm.get('official_email')?.dirty ||
                companyProfileForm.get('official_email')?.touched) &&
                companyProfileForm.get('official_email')?.hasError('invalidEmail')
              "
            >
              Please enter a valid email address.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (companyProfileForm.get('official_email')?.dirty ||
                companyProfileForm.get('official_email')?.touched) &&
                companyProfileForm.get('official_email')?.hasError('maxLengthEmail')
              "
            >
              Email cannot exceed 254 characters.
            </small>
                </div>
              </div>
              <div class="field-item">
                <label class="field-lbl">
                  <svg
                    class="lbl-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                    <path
                      d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                    />
                  </svg>
                  Website
                </label>
                <input
                  type="text"
                  class="standard-input"
                  formControlName="company_url"
                  placeholder="Enter website URL"
                />
                  <small
                    class="text-danger smaller-text"
                    *ngIf="(companyProfileForm.get('official_email')?.dirty ||
                      companyProfileForm.get('company_url')?.touched ) &&
                      companyProfileForm.get('company_url')?.hasError('invalidUrl')"
                  >
                    Please enter a valid website URL, e.g. https://www.example.com
                  </small>
              </div>
              <div class="field-item">
                <label class="field-lbl">
                  <svg
                    class="lbl-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                    />
                    <rect x="2" y="9" width="4" height="12" />
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                  LinkedIn
                </label>
                <input
                  type="text"
                  class="standard-input"
                  formControlName="linkedin_profile"
                  placeholder="LinkedIn profile URL"
                />
                <small
                class="text-danger smaller-text"
                *ngIf="(companyProfileForm.get('official_email')?.dirty ||
                  companyProfileForm.get('linkedin_profile')?.touched) &&
                  companyProfileForm.get('linkedin_profile')?.hasError('invalidUrl')
                "
              >
                Please enter a valid LinkedIn URL, e.g. https://www.linkedin.com/company/example
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  companyProfileForm.get('linkedin_profile')?.touched &&
                  companyProfileForm.get('linkedin_profile')?.hasError('invalidDomain')
                "
              >
                Please enter a valid LinkedIn profile or company URL.
              </small>
              </div>
            </div>

            <div class="field-item full-width">
              <label class="field-lbl">About</label>
              <textarea
                class="standard-textarea"
                formControlName="about_company"
                rows="3"
                maxlength="1000"
                placeholder="Tell us about your company..."
              ></textarea>
               <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('about_company')?.dirty ||
                    companyProfileForm.get('about_company')?.touched) &&
                  companyProfileForm.get('about_company')?.hasError('whitespace')
                "
              >
                About cannot contain only spaces.
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('about_company')?.dirty ||
                    companyProfileForm.get('about_company')?.touched) &&
                  companyProfileForm.get('about_company')?.hasError('minLengthAbout')
                "
              >
                About must be at least 2 characters long.
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('about_company')?.dirty ||
                    companyProfileForm.get('about_company')?.touched) &&
                  companyProfileForm.get('about_company')?.hasError('maxLengthAbout')
                "
              >
                About cannot exceed 1000 characters.
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  (companyProfileForm.get('about_company')?.dirty ||
                    companyProfileForm.get('about_company')?.touched) &&
                  companyProfileForm.get('about_company')?.hasError('excessiveSpaces')
                "
              >
                Please avoid multiple consecutive spaces.
              </small>
            </div>

            <div class="field-item full-width">
              <label class="field-lbl">
                <svg
                  class="lbl-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Office Locations
              </label>
              <div class="locations-editor" formArrayName="office_locations">
                <div
                  class="location-input-group"
                  *ngFor="let loc of officeLocations.controls; let i = index"
                >
                  <div style="position: relative; flex: 1; display: flex; align-items: center;">
                    <input
                      type="text"
                      class="standard-input flex-1"
                      [formControlName]="i"
                      placeholder="e.g. New York, USA"
                      (input)="onOfficeLocationInput($event, i)"
                      (focus)="onOfficeLocationFocus($event, i)"
                      (blur)="onOfficeLocationBlur(i)"
                    />
                    <div
                      class="suggestions-dropdown"
                      *ngIf="
                        activeLocationIndex === i &&
                        showOfficeLocationsDropdown &&
                        filteredOfficeLocations.length
                      "
                    >
                      <div
                        class="suggestion-item"
                        *ngFor="let loc of filteredOfficeLocations"
                        (mousedown)="selectOfficeLocation(loc, i)"
                      >
                        {{ loc }}
                      </div>
                    </div>
                  </div>
                  <button
                    class="btn-icon-remove"
                    (click)="removeLocation(i)"
                    title="Remove Location"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
                <button class="btn-add-location" (click)="addLocation()">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                  Add Location
                </button>
              </div>
            </div>

            <!-- Point of Contact Section -->
            <div formGroupName="contact">
              <h3 class="section-divider-title">Point of Contact</h3>
              <p class="section-desc">Primary recruiter contact for BeExpert</p>
              <div class="form-grid">
                <div class="field-item">
                  <label class="field-lbl">Contact Person</label>
                  <input
                    type="text"
                    class="standard-input"
                    formControlName="poc_name"
                    placeholder="Enter contact name"
                    [readonly]="true"
                  />
                </div>
                <div class="field-item">
                  <label class="field-lbl">
                    <svg
                      class="lbl-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                      />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    Email
                  </label>
                  <input
                    type="email"
                    class="standard-input"
                    formControlName="poc_email"
                    placeholder="Enter contact email"
                    [readonly]="true"
                  />
                </div>
                <div class="field-item">
                  <label class="field-lbl">
                    <svg
                      class="lbl-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                      />
                    </svg>
                    Mobile
                  </label>
                  <input
                    type="text"
                    class="standard-input"
                    formControlName="poc_phone"
                    placeholder="Enter contact mobile"
                    [readonly]="true"
                  />
                </div>
              </div>

              <!-- HR Contact Section -->
              <h3 class="section-divider-title">HR Contact</h3>
              <p class="section-desc">Hiring team contact details</p>
              <div class="form-grid">
                <div class="field-item">
                  <label class="field-lbl">HR Name</label>
                  <input
                    type="text"
                    class="standard-input"
                    formControlName="hr_name"
                    placeholder="Enter HR name"
                    [readonly]="true"
                  />
                </div>
                <div class="field-item">
                  <label class="field-lbl">
                    <svg
                      class="lbl-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                      />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    HR Email
                  </label>
                  <input
                    type="email"
                    class="standard-input"
                    formControlName="hr_email"
                    placeholder="Enter HR email"
                    [readonly]="true"
                  />
                </div>
                <div class="field-item">
                  <label class="field-lbl">
                    <svg
                      class="lbl-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                      />
                    </svg>
                    HR Phone
                  </label>
                  <input
                    type="text"
                    class="standard-input"
                    formControlName="hr_phone"
                    placeholder="Enter HR phone"
                    [readonly]="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
  <ng-template #showMessage>
    <p class="text-center">No Profile Data available</p>
  </ng-template>
</ng-template>
